import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {setLookIntroStep, setLookOpened} from "../../../../actions/lookFunctions";
import {
  getCartItemObject,
  getPriceWithCurrency,
  getQuotePriceWithTaxes,
  getTotalPrice,
  toFixedPrice
} from "../../../../misc/helpers";
import MaterialSpinner from "../../../ui/materialSpinner";
import {getLookList} from "../lookFunctions";
import {getCurrentRoomType} from "../../../appLayout";
import {LOOK_ROOM_TYPES} from "../../core/constants";
import {pricingIsLocked} from "../lookNavigationFunctions";
import LookFeaturePriceLocked from "./lookListFeature/lookFeaturePriceLocked";

const LookFooterCounts = (props) => {

  const {discountSections, fabricatorData, visualizersLoadedLength, qtActiveCategory, isPhoneNumberValidated} = props;
  const fabricatorSettings = fabricatorData.settings;

  if (!visualizersLoadedLength) {
    return (
      <div className="lm-footer__main-info">
        <MaterialSpinner/>
      </div>
    )
  }

  // const cartItemsToCalculate = cartItems.filter(cartItem => !(cartItem.cartFeature.dbFeature.sharedFeatureName || "").includes("undle sku"));
  // console.log("cartItemsToCalculate", cartItemsToCalculate);

  let cartItemsToCount = [];
  const featureGroups = getLookList();
  if (featureGroups) {
    featureGroups.forEach(parentObject => {
      if ((getCurrentRoomType() === LOOK_ROOM_TYPES.as) && parentObject.featureGroup.hideLayerCondition && parentObject.featureGroup.hideLayerCondition()) {
        return
      }
      if (parentObject.featureGroup.layerPositions) {
        Object.keys(parentObject.featureGroup.layerPositions).forEach(position => {
          if (parentObject.featureGroup.layerPositions[position]) {
            cartItemsToCount.push(getCartItemObject(parentObject.featureGroup.layerPositions[position], 1, qtActiveCategory))
          }
        })
      } else if (!parentObject.featureGroup.disabled && parentObject.featureGroup.activeFeature) {
        cartItemsToCount.push(getCartItemObject(parentObject.featureGroup.activeFeature, 1, qtActiveCategory))
      }
    })
  }

  // console.log("cartItemsToCount", cartItemsToCount);
  const totalPrice = getTotalPrice(null, false, cartItemsToCount);
  let grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

  let {pricingLocked, showPrice} = pricingIsLocked();
  if (fabricatorSettings.enableQuote && showPrice && !isPhoneNumberValidated) {
    showPrice = false;
  }

  return (
    <div className="lm-footer__main-info">
      <span className={showPrice ? "look-count" : "look-sum bold"}>
        {cartItemsToCount.length} <FormattedMessage id={"footer.cartItems"}/>
      </span>
      {showPrice ? (
        <span className="look-sum bold">
          {pricingLocked
            ? <LookFeaturePriceLocked lockedText={"grohe.feature.locked"}/>
            : getPriceWithCurrency(fabricatorSettings, toFixedPrice(grandTotal), null, !fabricatorData.isAmericanStandard)}
        </span>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {discountSections} = store.priceWorksheetState;
  const {visualizersLoaded} = store.serverState;
  const {qtActiveCategory} = store.qtState;
  const {canvasCount} = store.bathroomVisualizerState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    fabricatorData,
    discountSections,
    visualizersLoadedLength: visualizersLoaded.length,
    qtActiveCategory,
    canvasCount,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookIntroStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookFooterCounts)
